import { Component, OnInit, ChangeDetectionStrategy, Input, SimpleChanges } from '@angular/core';

import {
  CalendarEvent,
  CalendarView
} from 'angular-calendar';
import {
  isSameDay,
  isSameMonth
} from 'date-fns';
import { Observable, Subject } from 'rxjs';
import { MatSnackBar, MatDialog } from '@angular/material';
import { AddTrainingPlanComponent } from './add-training-plan/add-training-plan.component';
import { ActivatedRoute, Router } from '@angular/router';
import { TrainingPlanService } from 'src/app/services/portfolio/training-plan.service';


const colors: any = {
  red: {
    primary: '#ad2121',
    secondary: '#FAE3E3'
  },
  blue: {
    primary: '#1e90ff',
    secondary: '#D1E8FF'
  },
  yellow: {
    primary: '#e3bc08',
    secondary: '#FDF1BA'
  }
};


@Component({
  selector: 'app-training-plan',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './training-plan.component.html',
  styleUrls: ['./training-plan.component.scss']
})

export class TrainingPlanComponent implements OnInit {

  view: CalendarView = CalendarView.Month;
  CalendarView = CalendarView;

  viewDate: Date = new Date();

  allevents = []

  events: CalendarEvent[] = [];
  activeDayIsOpen: boolean;
  learnerId: any;
  refresh: Subject<any> = new Subject();
  loading: boolean;
  jobId
  @Input('learnerObj') learnerObj;
  @Input('job') singleJob
  constructor(public dialog: MatDialog, public _snackBar: MatSnackBar, public activatedRoute: ActivatedRoute,
    public _trainingPlanService: TrainingPlanService, private router: Router) { }

  ngOnInit() {
    this.activeDayIsOpen = true;
    this.activatedRoute.params.subscribe(param => {
      console.log('changes in training plan', param);
      if (param.id) {
        this.learnerId = param.id

      }
    })

    this.activatedRoute.queryParams.subscribe(param => {
      console.log("query params in evidence", param);
      this.jobId = param.job
    })
    this.getPlans()
  }

  ngOnChanges(changes: SimpleChanges): void {
    console.log('changes in training plan', changes);
  }

  // UTILITY
  closeOpenMonthViewDay() {
    this.activeDayIsOpen = false;
  }

  todayClicked() {
    console.log('Today Clicked===>', this.viewDate);
    this.activeDayIsOpen = true;
  }

  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }

  createEventObject(obj) {
    console.log("Creating Event object from = ", obj);

    var newEvent = {
      start: new Date(obj.date),
      title: obj.title,
      allDay: true,
      planid: obj.planid,
      description: obj.description
    }
    console.log("Event object created = ", newEvent);
    return newEvent;
  }

  makeEventsArrayForPlans(plan) {
    console.log("%cMaking array", "color:Orange", plan)
    if (plan.length < 1) return
    var events = [];

    var newObj = this.createEventObject({
      date: new Date(plan.date),
      title: plan.title,
      planid: plan._id,
      description: plan.description
    })

    this.allevents.push(newObj);
    events.push(newObj);
    this.refresh.next();
    // this.allevents.push(events)
    // }
    console.log("Events = ", events);
    return events;
    // this.events = events;
  }

  populateAllEvents(eventsDb) {
    return new Promise((resolve, reject) => {
      for (var i = 0; i < eventsDb.length; i++) {
        console.log("IN FOR LOOP");
        var events = this.makeEventsArrayForPlans(eventsDb[i]);
      }
      resolve(events)
      console.log("After for loop", this.allevents);
      this.loading = false;
      console.log("In populate allJobs", this.loading);
    }).then(res => {
      $('#loader-wrapper-2').hide()
      // if (this.oneJobFound == true) {
      //   console.log("ONE JOB FOUND")
      // }
      // else {
      //   let newObj = {
      //     start: new Date(),
      //     title: 'No Job Scheduled Today'
      //   }
      //   this.allevents.push(newObj)
      //   this.refresh.next()
      // }
    })
  }


  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    console.log("DAY CLICKED", date, events);

    if (isSameMonth(date, this.viewDate)) {
      if (
        (isSameDay(this.viewDate, date) && this.activeDayIsOpen === true)
      ) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
      }
      this.viewDate = date;
    }
  }

  eventClicked({ event }: { event: CalendarEvent }): void {
    console.log('Event clicked', event);
  }

  // TRAINING PLAN MODEL
  handleEvent(action: string, event): void {
    console.log("Handling event", { action, event })
    let data = {
      learnerId: this.learnerId,
      title: event.title,
      date: event.start,
      description: event.description,
      _id: event.planid,
      isEdit: true,
      learnerObj: this.learnerObj,
      jobId: this.jobId
    }
    this.openDialog(AddTrainingPlanComponent, { data }).subscribe(res => {
      console.log('res of when modal is closed', res);
      if (res != undefined && res.deleted == true) {
        let index = this.allevents.findIndex(x => x.planid === event.planid);
        console.log("index of deleted plan", index);
        this.allevents.splice(index, 1)
        this.refresh.next()
        console.log("total event list", this.allevents);

      }
      this.getPlans()
    })
  }

  addPlanModal() {
    let data = {
      learnerId: this.learnerId,
      isEdit: false,
      learnerObj: this.learnerObj,
      jobId: this.jobId
    }
    this.openDialog(AddTrainingPlanComponent, { data }).subscribe(res => {
      console.log('res', res);
      this.getPlans()
    })
  }

  getPlans() {
    this.allevents = []
    this._trainingPlanService.getPlans(this.learnerId, this.jobId).subscribe(res => {
      console.log('GET PLANS', res)
      if (res[0] && res[0].events) {
        this.populateAllEvents(res[0].events)
      }
      else {
        this.loading = false
      }
    })
  }



}
